<script>
    import { onMount } from 'svelte';
    import { db, user } from './stores.js';
    import Upcoming from './Upcoming.svelte';
    import Past from './Past.svelte';
    import Admin from './Admin.svelte';
    console.log('user from dashboard: ', $user);
    let events = [];
    let mode = 'dashboard';
    let isAdmin = false

    function getEvents(groups) {
        events = [];
        $db.collection("events").where("group.id","in", groups).orderBy("time", "asc")
            .get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    events = [...events, doc.data()];
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
    }

    onMount( async()=> {
        $db.collection("users").doc($user.email)
            .onSnapshot(function(doc) {
                console.log("User groups: ", doc.data().groups);
                isAdmin = doc.data().isAdmin;
                getEvents(doc.data().groups);
            });
    })
</script>

<section id="container">
    {#if mode === "dashboard"}
    <div></div>
        <div>
            <h1>Select one</h1>
            <button on:click={()=> mode = "upcoming"}>Upcoming events</button>
            <button on:click={()=> mode = "past"}>Past Broadcasts</button>
            {#if isAdmin}
                <button on:click={()=> mode = "admin"}>Admin</button>
            {/if}    
        </div>
        <div></div>
    {:else if mode === "upcoming"}
        <Upcoming events = {events.filter(e => e.status === 'upcoming')} />
    {:else if mode === "past"}
        <Past events = {events.filter(e => e.hasVideo === true)} />
    {:else if mode === "admin"}
        <Admin />
        {/if}
    {#if mode !== "dashboard"}
        <button id="back-to-home" on:click={()=> mode = "dashboard"}>&lt; home</button>
    {/if}
</section>

<style>
#container {
    width: 100%;
    height: 95vh;
    display: grid;
    place-items: center;
    grid-template-rows: auto 1fr auto;
}
#back-to-home {
    position: fixed;
    top: 20px;
    left: 20px;
}

</style>
